import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getCryptoBreakdown } from '../crypto.routes';
import type { CryptoOverviewPageModel } from '../types';

export const useCryptoBreakdownQuery = (
  positionDate?: string,
  options?: Omit<
    UseQueryOptions<CryptoOverviewPageModel, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<CryptoOverviewPageModel, Error>({
    queryKey: ['crypto-breakdown', positionDate],
    queryFn: () => getCryptoBreakdown(positionDate!),
    enabled: !!positionDate && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
